/** URL helper — stored photo paths like "/api/v1/files/..." must be prefixed
 *  with the backend origin; external URLs pass through untouched.
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("/api/")) return `${BACKEND}${path}`;
  return path;
}
